import { Portal, SystemStyleObject, TooltipRootProps, chakra, useToken } from '@chakra-ui/react'
import { Tooltip } from '@chakra-ui/react'
import { QuestionIcon } from '@phosphor-icons/react'
import { ComponentProps, FC, ReactNode } from 'react'

export const ExtraInformation: FC<
  { information: ReactNode; css?: SystemStyleObject } & Omit<TooltipRootProps, 'variant' | 'children'>
> = ({ information, css, ...props }) => {
  const color = useToken('colors', 'brand.blue')
  return (
    <Tooltip.Root {...props} interactive openDelay={20} closeDelay={100}>
      <Tooltip.Trigger height={'20px'}>
        <Q css={css} fontSize={'24px'} weight="fill" color={color} />
      </Tooltip.Trigger>
      <Portal>
        <Tooltip.Positioner>
          <Tooltip.Content p={2} w={'fit-content'} maxW={'330px'}>
            <Tooltip.Arrow bg={color} />
            {information}
          </Tooltip.Content>
        </Tooltip.Positioner>
      </Portal>
    </Tooltip.Root>
  )
}
export type ExtraInformationProps = ComponentProps<typeof ExtraInformation>

const Q = chakra(QuestionIcon)
